import React, { Fragment, useState } from 'react'

// import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'

// import { useWindowSize, useEventListener } from '../../../_helpers'
import {
    // Header,
    // ImageCard,
    // ArticleTextWrap,
    // Block,
    // Grid,
    // devices,
    // SecondaryButton,
    // PrimaryButton,
    colors,
} from '../../Common'


export const SimpleBlock = ({ pageBlock }) => (
    <TextBlock dangerouslySetInnerHTML={{ __html: pageBlock.content }} />
)

const TextBlock = styled.div`
    font-size: 48px;
    background: ${colors.red};
    color: ${colors.white};
    width: 100%;
    height: 100vh;

    p {
        margin: 0;
    }
`
